import { IAnio, IMes } from "./acuerdo";
import { IDetalleTema } from "./temas";

export interface IAcuerdo {
  cambioObservacion?: boolean;
  esRealizado: boolean;
  fechaAcuerdo: string;
  idFE: string;
  observaciones?: string | null; // La observaciones es opcional
  temas: number;
  urlUnico: boolean;
  expanded: boolean | false;
}

export const nuevoAcuerdo = {
  show: false,
  responsables: {
    administrador: [],
    analista: [],
    coordinador: [],
    supervisor: [],
  },
};

export interface IAcuerdos {
  acuerdos: IAcuerdo[];
  historico: IAcuerdo[];
  acuerdoActual: IAcuerdo[];
  tipoAcuerdo: number;
  nuevoAcuerdo: INuevoAcuerdoMrb;
}

export interface INuevoAcuerdoMrb {
  show: boolean;
  responsables: {
    administrador: any[];
    analista: any[];
    coordinador: any[];
    supervisor: any[];
  };
}

export interface IRAcuerdo {
  error: boolean;
  acuerdos: IAcuerdo[];
  items: number;
}

export interface IAcuerdoSeleccionado {
  acuerdo: IAcuerdo;
  temas: IDetalleTema[];
  archivos: IArchivoAcuerdo[];
  status: "edit" | "view" | "create" | string;
  statusTema?: string;
  ultimoTemaGuardado?: number | string | null;
}

export interface IArchivoAcuerdo {
  name: string;
  ulr: string;
  nuevo: boolean | false;
  fileId: number | 0;
  archivo: any;
}

export const fileId = Number(Date.now());

export interface IResponseArchivos {
  archivos: IArchivoAcuerdo[];
  error: boolean;
}

export const IStateAcuerdo = {
  acuerdos: [],
  historico: [],
  acuerdoActual: [],
  tipoAcuerdo: 0,
  nuevoAcuerdo,
};

export const stateIAcuerdo = {
  esRealizado: false,
  fechaAcuerdo: "",
  idFE: "",
  observaciones: ",", // La observaciones es opcional
  temas: 0,
  urlUnico: false,
  expanded: false,
};

export const SIAcuerdoSeleccionado = {
  acuerdo: stateIAcuerdo,
  temas: [],
  archivos: [],
  status: "",
};

export interface IArchivoEntrada {
  banEsActivo: number; // Puede ser tipo boolean si es que el valor 1 representa verdadero y 0 falso.
  id_entrada: string;
  indice: number;
  indiceEnTema?: number;
  metadata: string;
  nombre_archivo: string;
  url?: string;
}

export interface IEntregableEntrada {
  id_edo_entregable: number;
  id_entrada: string;
  id_entregable: string;
  indice: number | null;
  nombreEntregable: string;
  urlEntregable: string;
}

export interface IEntregablesArchivosEntrada {
  archivos: IArchivoEntrada[];
  entregables: IEntregableEntrada[];
  idTema?: string;
  idEntrada?: string;
}

export interface INuevaEntradaTema {
  id_entrada?: string;
  idEntrada: string;
  idCategorizacion: string;
  idTema: string;
  indiceEntrada: number;
  nombreEntrada: string;
  tieneSeguimiento: number;
  esActivo: number;
  remitente_descripcion: string;
  fecha_inicio: string;
  documentoSoporte: string;
  esDocumentoSoporte: boolean;
  archivos: any[];
  nombreEntradaCompleto: string;
  entregables: any[];
}

export const SIAcuerdos: IAcuerdos = {
  acuerdos: [],
  historico: [],
  acuerdoActual: [],
  tipoAcuerdo: 0,
  nuevoAcuerdo: nuevoAcuerdo,
};

export interface ITerminarTemaDespacho {
  id_tema: string;
  justificacionTema: string;
  id_usuario: string;
  usuario: string;
}

export interface ITerminarTemaDespachoNotificacion {
  nombreUsuario: string;
  empresa: string;
  tipoDespacho: string;
  nombreTema: string;
  descripcionTema: string;
  id_empresa: string;
  notificacion: string;
}

export interface IRAplazarTema {
  id_tema: string;
  id_acuerdo: string;
  id_usuario: string;
}

export interface IRAplazarTemaNotificacion {
  nombreUsuario: string;
  fechaAcuerdoAnterior: string;
  fechaAcuerdoActual: string;
  id_categorizacion: string;
  notificacion: string;
}
//Interface Request Nuevo Acuerdo
export interface IRNAcuerdo {
  tipoForma: number;
  fechaAcuerdo: string;
  banAgregarTema: boolean;
  temas?: INTemaAcuerdo[];
}

export interface IRNAcuerdoNotificacion {
  nombreUsuario: string;
  fechaAcuerdo: string;
  id_categorizacion: string;
}

export interface IRNAcuerdoNotiNuevoTema {
  nombreUsuario: string;
  fechaAcuerdo: string;
  nombreTema: string;
  descripcionTema: string;
  nombreAnalista: string;
  nombreSupervisor: string;
  nombreCoordinador: string;
  id_categorizacion: string;
}

export interface INTemaAcuerdo {
  nombreTema: string;
  descripcionTema: string;
  descripcionTema_html: string;
  tipoTema: number;
  esConfidencial: boolean;
  categorizacion: string;
  id_categoria: number;
  respAnalista: string;
  respSupervisor: string;
  respCoordinador: string;
  indiceTema: number;
}
